export const DEFAULT_SCORING_WEIGHTS = {
    severity: 0.25,
    intent: 0.15,
    scope: 0.20,
    recidivism: 0.15,
    deception: 0.15,
    accountability: 0.10,
};
//# sourceMappingURL=cards.js.map